module.exports = __webpack_public_path__ + "static/media/JournalOfWorldTrade.d676b3cc.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/JournalOfWorldTrade.png
// module id = 1761
// module chunks = 1